import React, {useState, useContext} from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import DisplaySettings from "../utils/globalSetting";

export default React.memo(function BatchCard ( {name, image, viewMore=true}  ) {
    const settings = useContext(DisplaySettings);
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);

    const handleButton = async () => {
        // set global variable: batchName
        settings.updateSettings({'type':"showBatchName", 'value':name});
        // go to page
        navigate("/resultsOneBatch");
    }

return (
    <Container
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    >        
        <div className="info-container">
            <img
                src={`data:image/jpeg;base64,${image}`}
                alt="card"
            />     
            <h4> {name} </h4>
            {/* <h6> Number of modules: {numModules} </h6> */}
        </div>

        {viewMore && isHovered && (
        <div className="hover" onClick={handleButton}>
            <div className="info-container">
            <img
                src={`data:image/jpeg;base64,${image}`} 
                alt="card"
            />     
            <h4> {name} </h4>
            <button> View more </button>
            </div>            
        </div>)}
        
    </Container>
);
});

const Container = styled.div`
max-width: 400px;
width: 400px;
height: 100%;
position: relative;
color: black;
background: white;
border-radius: 5px;
.info-container {
    gap: 0.5rem;    
    justify-content: center;
    text-align: center;
    padding: 1rem;
    img {
        width: 100%;
        height: 100%;
        z-index: 10;
    }
}
.hover {
    z-index: 99;
    height: max-content;
    width: 400px;
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    transition: 0.3s ease-in-out;
    background: white;
    border-radius: 5px;
    cursor: pointer;
    .info-container {  
        text-align: center; 
        padding: 1rem;        
        img {
            width: 100%;
            height: 100%;
            z-index: 10;
        }
        button {
            padding: 0.5rem 1rem;
            background-color: #E55B41;
            border: none;
            cursor: pointer;
            color: white;
            border-radius: 0.2rem;
            font-weight: bolder;
            font-size: 1.05rem;            
        }
    }
}
`;

